var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"movieinfo-poster"},[_c('img',{attrs:{"src":("" + (_vm.props.posterPath)),"alt":_vm.props.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }